var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertaiIconSingleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #141b8f;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #007be0;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M860.5,867.56s-364.2,73.89-543.25-105.17c-179.06-179.06-105.17-543.25-105.17-543.25,0,0,364.2-73.89,543.25,105.17,179.06,179.06,105.17,543.25,105.17,543.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M626.64,710.12c-141.37,0-256.39-115.01-256.39-256.39s115.01-256.39,256.39-256.39,256.39,115.02,256.39,256.39-115.01,256.39-256.39,256.39ZM626.64,288.89c-90.89,0-164.84,73.95-164.84,164.84s73.94,164.84,164.84,164.84,164.84-73.95,164.84-164.84-73.94-164.84-164.84-164.84Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 626.64,
    cy: 453.73,
    r: 92.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaiIconSingleLight);
export default __webpack_public_path__ + "static/media/alertai_icon_single_light.01a6f0d827744db69429e5c93fbe2c34.svg";
export { ForwardRef as ReactComponent };